import { Divider, Tabs } from "antd";
import React from "react";
import TitleHeader from "../../components/Common/TitleHeader";
import useResponsive from "../../hooks/useResponsive";
import { TABS_DATA } from "./TabsData";

const AboutUs = () => {
  const { isMobile } = useResponsive();

  return (
    <>
      <TitleHeader en="ABOUT US" th="รู้จักเรา" center={isMobile} />
      <Divider />
      <Tabs
        defaultActiveKey="1"
        tabPosition={isMobile ? "top" : "left"}
        items={TABS_DATA.map((data) => {
          return {
            label: data.label,
            key: data.label,
            children: data.component,
          };
        })}
      />
    </>
  );
};

export default AboutUs;
